import fontawesome from "@fortawesome/fontawesome"
import faCaretRight from "@fortawesome/fontawesome-free-solid/faCaretRight"
import faAngleRight from "@fortawesome/fontawesome-free-solid/faAngleRight"
import faPhone from "@fortawesome/fontawesome-pro-regular/faPhone"
import faCode from "@fortawesome/fontawesome-pro-regular/faCode"
import faEnvelopeRegular from "@fortawesome/fontawesome-free-regular/faEnvelope"
import faEnvelopeSolid from "@fortawesome/fontawesome-free-solid/faEnvelope"
import faObjectUngroup from "@fortawesome/fontawesome-free-regular/faObjectUngroup"
import faChevronRight from "@fortawesome/fontawesome-pro-regular/faChevronRight"
import faTint from "@fortawesome/fontawesome-pro-regular/faTint"
import faArrowRight from "@fortawesome/fontawesome-free-solid/faArrowRight"
import faBriefcase from "@fortawesome/fontawesome-free-solid/faBriefcase"
import faMapMarkerAlt from "@fortawesome/fontawesome-free-solid/faMapMarkerAlt"
import faBuilding from "@fortawesome/fontawesome-free-solid/faBuilding"
import faBullseye from "@fortawesome/fontawesome-free-solid/faBullseye"
import faGlobe from "@fortawesome/fontawesome-pro-regular/faGlobe"
import faDatabase from "@fortawesome/fontawesome-free-solid/faDatabase"
import faCheck from "@fortawesome/fontawesome-free-solid/faCheck"
import faHandshake from "@fortawesome/fontawesome-pro-regular/faHandshake"
import faFileAlt from "@fortawesome/fontawesome-pro-regular/faFileAlt"
import faUserCog from "@fortawesome/fontawesome-free-solid/faUserCog"
import faToolbox from "@fortawesome/fontawesome-free-solid/faToolbox"

fontawesome.library.add(
  faCaretRight,
  faAngleRight,
  faPhone,
  faEnvelopeRegular,
  faEnvelopeSolid,
  faChevronRight,
  faCode,
  faObjectUngroup,
  faTint,
  faArrowRight,
  faBriefcase,
  faMapMarkerAlt,
  faBuilding,
  faBullseye,
  faGlobe,
  faDatabase,
  faCheck,
  faHandshake,
  faFileAlt,
  faUserCog,
  faToolbox
)



// WEBPACK FOOTER //
// ./src/utils/icons.js